export const REPORT_TYPES = {
  UAM_REPORT: "uam",
  MAINTENANCE_SYSTEM: "maintenance-system",
};
